import { Mensagem, TituloPersonalizado } from "./styles";

export default function Publicacoes() {
    return (
        <Mensagem>
            <TituloPersonalizado>Recurso em Manutenção</TituloPersonalizado>
        </Mensagem>
        
    );
}